import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { addUrlParams, getQueryString } from '../../helpers/url';
import ContentApp from '../../components/ContentApp';
import './styles.css';
import { deregisterMessagesListener, registerMessagesListener } from '../../helpers/iframe';

const WelletProIframeScreen = ({ history }) => {
  const associate = useSelector((state) => state.associates);
  const url = getQueryString('url');

  useEffect(() => {
    registerMessagesListener(window, (e) => {
      if (e.data.type === 'GO_BACK') {
        history.push('/restaurant-list');
      } else if (e.data.type === 'RESERVATION_SUCCESS') {
        history.push('/');
      }
    });

    return () => {
      deregisterMessagesListener(window);
    };
  }, []);

  return (
    <>
      <ContentApp classes='p-0'>
      <iframe
        title='Wellet Pro'
        src={`${addUrlParams(decodeURIComponent(url), {
          wlToken: encodeURIComponent(associate.user.wlToken),
          isEmbedded: true,
        })}`}
        style={{
          width: '100%',
          minHeight: '100%',
          border: 'none',
          margin: 0,
          padding: 0,
          display: 'block',
          opacity: 1,
          transition: 'opacity 0.3s ease-in-out',
        }}
        allow="fullscreen; geolocation; microphone; camera; clipboard-write self https://rn.pwa.wellet.pro; clipboard-read self https://rn.pwa.wellet.pro; web-share"
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
      />
      </ContentApp>
    </>
  );
};

export default WelletProIframeScreen;